import type { z } from 'zod';

import { statusMutationSchema } from '@/_schemas/status-input';

import { recruitingJobCategoryQuerySchema } from './recruiting-job-category-query-schema';

export const recruitingJobCategoryUpdateSchema = recruitingJobCategoryQuerySchema
  .pick({ id: true, name: true })
  .extend({ status: statusMutationSchema });

export type RecruitingJobCategoryUpdateSchema = z.infer<typeof recruitingJobCategoryUpdateSchema>;

export const recruitingJobCategoryCreateSchema = recruitingJobCategoryUpdateSchema.pick({ name: true, status: true });
export type RecruitingJobCategoryCreateSchema = z.infer<typeof recruitingJobCategoryCreateSchema>;
